// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const victini: PokeData = {
  "id": 494,
  "name": "victini",
  "height": 4,
  "weight": 40,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FIRE
  ],
  "api_moves": [
    "headbutt",
    "double-edge",
    "confusion",
    "quick-attack",
    "focus-energy",
    "reversal",
    "endure",
    "overheat",
    "flare-blitz",
    "zen-headbutt",
    "flame-burst",
    "flame-charge",
    "stored-power",
    "incinerate",
    "final-gambit",
    "inferno",
    "work-up",
    "searing-shot",
    "v-create"
  ],
  "moves": [
    "headbutt",
    "quick-attack",
    "flare-blitz",
    "zen-headbutt",
    "psywave",
    "fire-spin",
    "sunny-day",
    "blaze-kick",
    "future-sight",
    "healing-wish",
    "psy-pulse",
    "fire-ball",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 255,
    "item": null,
    "species": [
      {
        "name": "victini",
        "order": 495,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
